import React, { useState } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import Paper from "@mui/material/Paper"
import withStyles from "@mui/styles/withStyles"
import TextField from "@mui/material/TextField"
import Table from "@mui/material/Table"
import TableContainer from "@mui/material/TableContainer"
import TableBody from "@mui/material/TableBody"
import Select from "@mui/material/Select"
import TableCell from "@mui/material/TableCell"
import TableRow from "@mui/material/TableRow"
import MenuItem from "@mui/material/MenuItem"
import Checkbox from "@mui/material/Checkbox"
import TablePagination from "@mui/material/TablePagination"
import ProductsTagsEnhancedTableToolbar from "../../../../../components/table-utils/ProductsTags/ProductsTagsEnhancedTableToolbar"
import {
    showProductTagEdit,
    showProductTagRead
} from "../../../../../actions/ProductsTags/ProductsTags"
import ProductsTagsEnhancedTableHead
    from "../../../../../components/table-utils/ProductsTags/ProductsTagsEnhancedTableHead"
import moment from "moment"
import { productTagsTypes } from "../../../../../utils/productTagsUtils"
import { getSorting, stableSort, TableDateFormat } from "../../../../../components/table-utils/utils"
import { setSearchValue, filterWithSearchValue } from "../../../../../utils"

const styles = {
    root: {
        width: "100%"
    },
    searchFieldDiv: {
        paddingLeft: 24,
        width: 300,
        marginBottom: 20,
        display: "flex"
    },
    searchFieldInput: {
        width: 300
    },
    tableWrapper: {
        overflowX: "auto",
    },
    selectType: {
        marginLeft: 20,
        width: 200
    }
}

function createData(productTag) {
    return {
        objectId: productTag.objectId,
        name: productTag.name,
        type: productTagsTypes.find(type => type.value === productTag.type) ? productTagsTypes.find(type => type.value === productTag.type).label : "Inconnu",
        createdAt: moment(productTag.createdAt).format(TableDateFormat),
        updatedAt: moment(productTag.updatedAt).format(TableDateFormat)
    }
}

export const ProductsTagsList = ({classes, productsTags, showProductTagRead, showProductTagEdit}) => {
    const storage = JSON.parse(localStorage.getItem("searchValue"))
    const [order, setOrder] = useState("asc")
    const [orderBy, setOrderBy] = useState("name")
    const [selected, setSelected] = useState([])
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [searchFilter, setSearchFilter] = useState((storage && storage.productTagsList)?storage.productTagsList:null)
    const [selectType, setSelectType] = useState("ALL")
    const [filterProductsTags, setFilterProductsTags ] = useState(filterWithSearchValue(searchFilter, productsTags))
    const [data, setData] = useState(filterProductsTags.map(createData))


    const handleRequestSort = (event, property) => {
        const isDesc = orderBy === property && order === "desc"
        setOrder(isDesc ? "asc" : "desc")
        setOrderBy(property)
    }

    const handleSelectAllClick = event => {
        const newSelected = event && event.target && event.target.checked
            ? data.map(subcontractor => subcontractor.objectId)
            : []
        setSelected(newSelected)
    }

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id)
        let newSelected = []

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id)
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1))
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1))
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            )
        }
        setSelected(newSelected)
    }

    const updateSearchFilter = (event) => {
        const searchValue = event && event.target && event.target.value
            ? event.target.value
            : null

        setSearchFilter(searchValue)
        setSearchValue(searchValue, "productTagsList")
        updateFilters(searchValue, selectType)
        setPage(0)
    }

    const onSelectChange = (event) => {
        setSelectType(event.target.value)
        updateFilters(searchFilter, event.target.value)
        setPage(0)
    }

    const updateFilters = (search, type) => {
        let newProductsTagsFilter = filterWithSearchValue(search, productsTags)

        if (type !== "ALL") {
            newProductsTagsFilter = newProductsTagsFilter.filter(elem => elem.type === type)
        }

        setFilterProductsTags(newProductsTagsFilter)
        setData(newProductsTagsFilter.map(createData))
        setPage(0)
    }

    const renderSelectTypes = () => {
        return productTagsTypes.map(elem => {
            return (
                <MenuItem key={elem.value} value={elem.value}>{elem.label}</MenuItem>)
        })
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(parseInt(event.target.value, 10))
        setPage(0)
    }

    const isItSelected = id => selected.indexOf(id) !== -1
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage)

    return (
        <Paper elevation={0} className={classes.root}>
            <ProductsTagsEnhancedTableToolbar
                numSelected={selected.length}
                productsTags={productsTags}
                createProductTag={showProductTagEdit}
                selected={selected}
            />
            <div className={classes.searchFieldDiv}>
                <TextField
                    variant="standard"
                    defaultValue={searchFilter}
                    className={classes.searchFieldInput}
                    onChange={updateSearchFilter}
                    label="Rechercher un tag"
                />
                <Select
                    variant="standard"
                    className={classes.selectType}
                    name="type"
                    label="Type"
                    placeholder="Type"
                    value={selectType}
                    onChange={onSelectChange}
                >
                    {renderSelectTypes()}
                </Select>
            </div>
            <TableContainer className={classes.tableWrapper}>
                <Table className={classes.table} aria-labelledby="tableTitle">
                    <ProductsTagsEnhancedTableHead
                        numSelected={selected.length}
                        onRequestSort={handleRequestSort}
                        onSelectAllClick={handleSelectAllClick}
                        order={order}
                        orderBy={orderBy}
                        rowCount={filterProductsTags.length}
                    />
                    <TableBody>
                        {
                            stableSort(data, getSorting(order, orderBy))
                                .slice(rowsPerPage * page, rowsPerPage * page + rowsPerPage)
                                .map(elem => {
                                const isSelected = isItSelected(elem.objectId)
                                return (
                                    <TableRow
                                        hover
                                        role="checkbox"
                                        aria-checked={isSelected}
                                        tabIndex={-1}
                                        key={elem.objectId}
                                        selected={isSelected}
                                    >
                                        <TableCell padding="checkbox" onClick={event => handleClick(event, elem.objectId)}>
                                            <Checkbox checked={isSelected} color="secondary" />
                                        </TableCell>
                                        <TableCell className={classes.column} onClick={() => showProductTagRead(elem.objectId)}>{elem.objectId}</TableCell>
                                        <TableCell className={classes.column} onClick={() => showProductTagRead(elem.objectId)}>{elem.name}</TableCell>
                                        <TableCell className={classes.column} onClick={() => showProductTagRead(elem.objectId)}>{elem.type}</TableCell>
                                        <TableCell className={classes.column} align="right" onClick={() => showProductTagRead(elem.objectId)}>{elem.createdAt}</TableCell>
                                        <TableCell className={classes.column} align="right" onClick={() => showProductTagRead(elem.objectId)}>{elem.updatedAt}</TableCell>
                                    </TableRow>
                                )
                            })
                        }
                        {
                            emptyRows > 0 && (
                                <TableRow style={{ height: 49 * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )
                        }
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                component="div"
                rowsPerPageOptions={[5, 10, 25]}
                count={data.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                labelRowsPerPage="Tags par page"
            />
        </Paper>
    )
}

ProductsTagsList.propTypes = {
    classes: PropTypes.object.isRequired
}

const StyledProductsTagsList = withStyles(styles)(ProductsTagsList)

export default connect(state => {
    return {
        productsTags: state.productsTags.productsTags
    }
}, {
    showProductTagEdit,
    showProductTagRead
})(StyledProductsTagsList)
